"use client";

import React from "react";
import { Card } from "../common/card";

export interface Stat {
  number: string;
  label: string;
}

export interface StatsSectionProps {
  title: string;
  subtitle: string;
  stats: Stat[];
  image?: string;
  imageAlt?: string;
  imagePosition?: "left" | "right";
}

export function StatsSection({
  title,
  subtitle,
  stats,
  image,
  imageAlt = "Platform image",
  imagePosition = "left"
}: StatsSectionProps) {
  const imageElement = image && (
    <div className={imagePosition === "left" ? "order-2 md:order-1" : "order-2 md:order-2"}>
      <img 
        src={image}
        alt={imageAlt}
        className="w-full rounded-lg"
      />
    </div>
  );

  const contentElement = (
    <div className={imagePosition === "left" ? "order-1 md:order-2" : "order-1 md:order-1"}>
      <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        {title}
      </h2>
      <p className="text-lg text-gray-600 mb-8">
        {subtitle}
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {stats.map((stat, idx) => (
          <Card key={idx} className="p-4 text-center bg-gray-100 border-0">
            <div className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
              {stat.number}
            </div>
            <div className="text-sm text-gray-500 leading-tight">{stat.label}</div>
          </Card>
        ))}
      </div>
    </div>
  );

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {imagePosition === "left" ? (
            <>
              {imageElement}
              {contentElement}
            </>
          ) : (
            <>
              {contentElement}
              {imageElement}
            </>
          )}
        </div>
      </div>
    </section>
  );
}